export interface Bono {
  numero: string;
  icon: string;
  titulo: string;
  descripcion: string;
  temario: string[];
  accent: {
    text: string;
    bg: string;
    chipBg: string;
    border: string;
  };
}

export const bonos: Bono[] = [{
  numero: '01',
  icon: '⚽',
  titulo: 'Banco de Ejercicios Técnicos',
  descripcion: '+80 ejercicios técnicos con descripción, variantes y objetivos claros. Nunca más repetir los mismos 10 ejercicios de siempre.',
  temario: ['Ejercicios de pase y recepción por nivel.', 'Control, conducción y protección del balón.', 'Remate y definición específica para mujeres.', 'Juego aéreo y disputas.', 'Variantes de dificultad por ejercicio.', 'Indicaciones de espacio, tiempo y jugadoras necesarias.', 'Objetivos técnicos claramente definidos por ejercicio.', 'Integración con trabajo físico dentro del campo.'],
  accent: {
    text: 'text-blue-600',
    bg: 'bg-blue-500',
    chipBg: 'bg-blue-50',
    border: 'border-blue-200'
  }
}, {
  numero: '02',
  icon: '🦵',
  titulo: 'Protocolo Anti-Lesiones',
  descripcion: 'Rutinas de prevención específicas para la mujer futbolista. El bono que puede salvar la temporada de tus jugadoras.',
  temario: ['Protocolo específico para rodilla y LCA en la mujer.', 'Prevención de lesiones de tobillo y cadera.', 'Rutinas de entrada en calor preventiva.', 'Vuelta a la actividad post-lesión paso a paso.', 'Ejercicios de propiocepción y estabilización.', 'Señales de alerta que todo entrenador debe conocer.', 'Protocolo de emergencia en el campo.', 'Cuándo derivar y a quién.'],
  accent: {
    text: 'text-red-600',
    bg: 'bg-red-500',
    chipBg: 'bg-red-50',
    border: 'border-red-200'
  }
}, {
  numero: '03',
  icon: '📝',
  titulo: 'Plantillas de Planificación Editables',
  descripcion: 'Plantillas en PDF listas para completar semana a semana. El soporte operativo que hace que todo funcione en la práctica.',
  temario: ['Plantilla de microciclo semanal completo.', 'Control y registro de cargas de entrenamiento.', 'Registro de asistencia y seguimiento de jugadoras.', 'Planilla de evaluación técnica individual.', 'Hoja de sesión lista para completar.', 'Calendario de temporada editable.', 'Registro de análisis de partido propio y rival.', 'Formato imprimible o para completar en tablet.'],
  accent: {
    text: 'text-purple-600',
    bg: 'bg-purple-500',
    chipBg: 'bg-purple-50',
    border: 'border-purple-200'
  }
}, {
  numero: '04',
  icon: '📊',
  titulo: 'Test de Evaluación del Plantel',
  descripcion: 'Sistema completo para evaluar el nivel físico y técnico de tus jugadoras. Conocé con datos reales el nivel de cada una.',
  temario: ['Tests físicos adaptados a la mujer futbolista.', 'Evaluación técnica por posición.', 'Tablas de referencia por categoría.', 'Cómo interpretar y usar los resultados en tu planificación.', 'Cómo comunicar los resultados a las jugadoras.', 'Planilla de seguimiento de evolución mensual.', 'Re-test para medir progreso real.', 'Cómo ajustar la planificación según los resultados.'],
  accent: {
    text: 'text-teal-600',
    bg: 'bg-teal-500',
    chipBg: 'bg-teal-50',
    border: 'border-teal-200'
  }
}, {
  numero: '05',
  icon: '🥗',
  titulo: 'Guía de Nutrición para la Jugadora',
  descripcion: 'Lo que todo entrenador debe saber sobre alimentación femenina en el deporte. Sin ser nutricionista.',
  temario: ['Nutrición específica para la mujer deportista.', 'Qué comer antes, durante y después del entrenamiento.', 'Hidratación y rendimiento en el campo.', 'Deficiencia de hierro: el problema más común en la mujer deportista.', 'Cómo hablar de alimentación con tus jugadoras.', 'Señales de alarma que el entrenador debe conocer.', 'Cuándo y cómo derivar a un especialista.', 'Mitos y verdades de la nutrición deportiva femenina.'],
  accent: {
    text: 'text-emerald-600',
    bg: 'bg-emerald-500',
    chipBg: 'bg-emerald-50',
    border: 'border-emerald-200'
  }
}];
